import { usePaymentsStore } from '@stores/payments'

import { useCsRoutes } from '@composables/routes/cs-route.hook'
import { useToast } from '@hooks/toast/index.hook'

interface OrdersApiReturn {
  fetchOrders: () => Promise<void>
  fetchOrdersNextPage: () => Promise<void>
}

export const useOrdersApi = (): OrdersApiReturn => {
  const { $axios } = useNuxtApp()
  const paymentsStore = usePaymentsStore()
  const toast = useToast()

  const url = useCsRoutes('orders')

  const fetchOrders = async (): Promise<void> => {
    try {
      if(!url) {
        console.warn('missing url for orders.hook.ts')
        return
      }
      paymentsStore.setOrders(null)
      paymentsStore.setOrdersLoading(true)

      const { data } = await $axios.get(url)
      const orders = data?.data
      // TODO: maybe add runtime validation for data that was actually received

      if (data?.success) {
        if (!orders) {
          console.error('Orders data is missing from API response')
          return
        }
        // FIXME: change structure for data to reflect progress reports data stracture as well - data array is different field from meta data (pagination)
        paymentsStore.setOrders(orders)
      }
    } catch (err: any) {
      console.error('unable to retrieve orders.hook.ts:', err)

      toast.error({
        title: 'Error',
        description: err.message ?? 'Something went wrong',
      })
    } finally {
      paymentsStore.setOrdersLoading(false)
    }
  }

  const fetchOrdersNextPage = async (): Promise<void> => {
    try {
      if(!paymentsStore.orders?.next_page_url) {
        console.warn('missing url for orders.hook.ts next page')
        return
      }

      paymentsStore.setOrdersLoading(true)

      const { data } = await $axios.get(paymentsStore.orders.next_page_url)

      const orders = data?.data || {}
      // TODO: maybe add runtime validation for data that was actually received

      if (data?.success) {
        if (!orders) {
          console.error('Orders data is missing from API response')
          return
        }

        paymentsStore.setOrders({ ...orders, data: [...paymentsStore.orders.data, ...orders.data] })
      }
    } catch (err: any) {
      toast.error({
        title: 'Error',
        description: err.message ?? 'Something went wrong',
      })
      console.error('unable to retrieve orders.hook.ts next page', err)

    } finally {
      paymentsStore.setOrdersLoading(false)
    }
  }

  return {
    fetchOrders,
    fetchOrdersNextPage,
  }
}
